import {Activity, ActivityType} from '../activity';
import {Observable} from 'rxjs';
import {ActivityPropertyDataType} from '../enumerations/activity-property-data-type';
import {IDGeneratorType} from '../enumerations/id-generator-type';
import {LazyDialogService} from './lazy-dialog.service';

export class IDGeneratorActivity extends Activity {
  public Type: IDGeneratorType;
  public FilePath: string;
  public Check: boolean;
  public TargetAttribute: string;
  public StartNum: string;
  public EndNum: string;
  public Database: string;
  public QueueId: string;
  public Server: string;
  public Format: string;

  constructor(activityNode: any, lazyDialogService: LazyDialogService) {
    super(lazyDialogService, ActivityType.IDGenerator);
    this._properties['Type'] = ActivityPropertyDataType.IDGENERATOR_TYPE;
    this._properties['Check'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['FilePath'] = ActivityPropertyDataType.STRING;
    this._properties['TargetAttribute'] = ActivityPropertyDataType.STRING;
    this._properties['StartNum'] = ActivityPropertyDataType.STRING;
    this._properties['EndNum'] = ActivityPropertyDataType.STRING;
    this._properties['Database'] = ActivityPropertyDataType.STRING;
    this._properties['QueueId'] = ActivityPropertyDataType.STRING;
    this._properties['Server'] = ActivityPropertyDataType.STRING;
    this._properties['Format'] = ActivityPropertyDataType.STRING;

    this.parse(activityNode);
  }

  beforeSave(): void {
    super.beforeSave();
  }

  openDialog(): Observable<any> {
    return this.openDialogLazy('id-generator', this.dialogConfig);
  }
}
